<template>
  <!-- blog-section start -->
  <section class="blog-section pt-120 pb-120">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="post-item post-item--list" v-for="(imagen,index) in bannerImagenes" :key="index">
          <!--  <div class="post-item-header">
               <a class="post-date">16<br>Dec</a>
              <h3 class="post-title"><a href="#0">Curabitur architecto donec donec laborumero nonummy lectus, in nec vehicula quam</a></h3>
            </div>-->
            <div class="thumb">
              <img :src="imagen.url" alt="image">
            </div>
            
            <div class="content">
              <p>Lorem ipsum dolor sit amet, eu nec odio volutpat neque, neque lacinia magna eros wisi qutusn semper, wisi rhoncus sed euismod vitae eleifend, amet phasellus wisi quam ut eu gravida. Risus erat tellus sodales ut leo nec</p>
           
            </div>
          </div><!-- post-item end -->
   
          <div class="post-item post-item--list">

            <div class="thumb">
              <img src="assets/images/blog/m3.jpg" alt="image">
              <div class="video-icon">
                <a href="https://www.youtube.com/embed/aFYlAzQHnY4" data-rel="lightcase:myCollection"><i class="fa fa-play"></i></a>
              </div>
            </div>
           
            <div class="content">
              <p>Lorem ipsum dolor sit amet, eu nec odio volutpat neque, neque lacinia magna eros wisi qutusn semper, wisi rhoncus sed euismod vitae eleifend, amet phasellus wisi quam ut eu gravida. Risus erat tellus sodales ut leo nec</p>

            </div>
          </div><!-- post-item end -->
         
        </div>
       
      </div>
    </div>
  </section>
</template>

<script>

import {storage} from "@/firebase";


export default {
  name: 'Promocion',
  components: {

  },
   data: () => ({   
     bannerImagenes : [],   
  }),
  created(){
    this.getImagenes()
  },
  methods:{
    getImagenes(){
      let arrayTempImg = []
      // Creamos una referencia a la carpeta de la cual queremos obtener sus imagenes
      var listRef = storage.ref().child('/imagenes/promociones');

      //Mediante un ciclo obtenemos el listado de imagenes
      listRef.listAll().then(function(res) {
        
        res.items.forEach(function(itemRef) {
          itemRef.getDownloadURL().then(function(url_img) {
                  //guardamos las url de las imagenes en un array temporal
                  console.log(url_img)
                  arrayTempImg.push({
                        url : url_img,                      
                  });
              }).catch(function(error) {
                  console.log(error)
              });
        });
      }).catch(function(error) {
         console.log(error)
      });
      this.bannerImagenes = arrayTempImg
    },
  
    


  }
}
</script>
